import { useUserSetting } from './use-user-setting';
import { UserSettings } from '../enums/user-settings/user-settings';

export const useHasVerifiedPhone = () => {
  const hasVerifiedPhoneSetting = useUserSetting(UserSettings.userHasVerifiedPhoneNumber.settingName);

  if (!hasVerifiedPhoneSetting) {
    return {
      verifiedPhoneState: '',
      date: null,
    };
  }

  // Split the setting value to get the state and date
  // Example: "verified-2025-07-07" or "show_banner-2025-10-01"
  const settingParts = hasVerifiedPhoneSetting.split('-');
  if (settingParts.length === 1) {
    return {
      verifiedPhoneState: settingParts[0],
      date: null,
    };
  }

  const verifiedPhoneState = settingParts[0];
  const date = settingParts.slice(1).join('-');

  return {
    verifiedPhoneState,
    date,
  };
};
